import React from "react";
import { Redirect, useLocation, useHistory, NavLink } from 'react-router-dom';
import { marked } from "marked";
import { Helmet } from "react-helmet";


function waitForGlobal(name, timeout = 300)
{
    return new Promise((resolve, reject) =>
    {
        let waited = 0

        function wait(interval)
        {
            setTimeout(() =>
            {
                waited += interval
                // some logic to check if script is loaded
                // usually it something global in window object
                if (window[name] !== undefined)
                {
                    return resolve()
                }
                if (waited >= timeout * 1000)
                {
                    return reject({ message: 'Timeout' })
                }
                wait(interval * 2)
            }, interval)
        }

        wait(30)
    })
}

class Articles extends React.Component
{
    constructor(props)
    {
        // Necessary to collect the parameter
        super(props);
        this.slug_id = this.props.match.params.id
    }
    componentDidMount()
    {
        waitForGlobal('MathJax').then(() =>
        {
            window.top.MathJax.Hub.Config({
                tex2jax: {
                    inlineMath: [['$', '$']],
                    displayMath: [['$$', '$$']],
                },
            })
        })
        if (window.top.MathJax != null)
        {
            window.top.MathJax.Hub.Queue(['Typeset', window.top.MathJax.Hub])
        }
        console.log("MOUNT avec slug " + this.slug_id)



        // MathJax
        /*console.log("Reloading MathJax")
        const script_mathjax = document.createElement("script");
        script_mathjax.text = "MathJax.Hub.Config({tex2jax: {inlineMath: [['$', '$']]}});    HubQueue();  console.log('d')      ";
        script_mathjax.type = "text/x-mathjax-config";
        script_mathjax.async = true;
        document.head.appendChild(script_mathjax);


        console.log("Reloading MathJax 2")
        const script_mathjax2 = document.createElement("script");
        script_mathjax2.src = "https://cdn.mathjax.org/mathjax/latest/MathJax.js?config=TeX-AMS_CHTML";
        script_mathjax2.async = true;
        document.body.appendChild(script_mathjax2);
        // Mermaid
        console.log("Reloading Mermaid")
        const script_mermaid = document.createElement("script");
        script_mermaid.src = "/mermaid.js";
        script_mermaid.async = true;
        document.body.appendChild(script_mermaid);

        const script_mermaid2 = document.createElement("script");
        script_mermaid2.text = "mermaid.initialize();"
        script_mermaid2.async = true;
        document.body.appendChild(script_mermaid2);*/

        // Highlight JS
        console.log("Reloading Highlight JS")
        const script_highlight = document.createElement("script");
        script_highlight.text = "hljs.highlightAll();";
        script_highlight.async = true;
        document.body.appendChild(script_highlight);

    }

    render()
    {
        console.log("rendering")
        let article_slug = this.slug_id;
        console.log("Article slug : ", article_slug)

        // Collecting the articles list

        var URL_ARTICLES_LIST = "https://raw.githubusercontent.com/lcsrodriguez/articles/main/list.json";
        var xhr = new XMLHttpRequest();
        xhr.open("GET", URL_ARTICLES_LIST, false);
        xhr.send(null);

        var json = JSON.parse(xhr.responseText);
        //console.log(json)


        // Method 1 for getting the slugs list
        //console.log("K", Object.keys(json))

        // Method 2 for getting the slugs list
        var elts = Object.values(json);
        console.log("--------------------")
        console.log(elts);

        var registered_slugs = elts.map(function (c)
        {
            return c.slug;
        });
        //console.log("R", registered_slugs);

        // Checking if the article slug is valid
        if (registered_slugs.includes(article_slug))
        {
            if (window.location.hostname == "localhost")
            {
                // Local environment activated
                var URL_ARTICLE_CONTENT = `file:///Users/lucas/projets/articles/articles/${article_slug}/article.md`

            } else
            {
                // Getting the article content
                var URL_ARTICLE_CONTENT = `https://raw.githubusercontent.com/lcsrodriguez/articles/main/articles/${article_slug}/article.md`;
            }
            var URL_ARTICLE_CONTENT = `https://raw.githubusercontent.com/lcsrodriguez/articles/main/articles/${article_slug}/article.md`;

            //console.log("Getting the article content : ", URL_ARTICLE_CONTENT);
            var xhr = new XMLHttpRequest();
            xhr.open("GET", URL_ARTICLE_CONTENT, false);
            xhr.send(null);
            var article_content = xhr.responseText;
            //console.log(article_content);
            //var formatted_article_content = marked.parse(article_content);
            function unEntity(str)
            {
                return str.replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">");
            }
            var formatted_article_content = unEntity(article_content)
            formatted_article_content = marked.parse(formatted_article_content);
            /*
                        formatted_article_content = formatted_article_content.replace(/&amp;|&/g, '');
            formatted_article_content = formatted_article_content.replace(/gt;/g, '>');
            formatted_article_content = formatted_article_content.replace(/lt;/g, '<');

                        .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
            */
            //console.log(formatted_article_content)

            //Collecting the last modified data of the article
            var xhr = new XMLHttpRequest();

            //var url = "https://api.github.com/repos/lcsrodriguez/articles/git/trees/main"

            /*var URL_ARTICLES_LIST = `https://api.github.com/repos/lcsrodriguez/articles/commits?path=articles/${article_slug}/&page=1&per_page=1`;
    
            // L'usage de l'API GitHub n'est pas une bonne idée
            xhr.open("GET", URL_ARTICLES_LIST, false);
            xhr.setRequestHeader("Accept", "application/vnd.github.v3+json");
            xhr.setRequestHeader("Authorization", "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");
            xhr.send();
    
            //console.log(xhr.responseText)
            var json2 = JSON.parse(xhr.responseText);
            console.log(json2)*/
            var last_modified_date = "1"; //json2[0]["commit"]["author"]["date"].split("T")[0];
            var page_title = `Article ${article_slug}`

            // Retrieving the informations on 
            var article_prop;
            console.log(elts.map((value) =>
            {
                if (value.slug == article_slug)
                {
                    article_prop = value
                }
            }));


            return (
                <div>
                    <Helmet title={page_title}>
                        <title>{article_prop.title} | Lucas RODRIGUEZ</title>
                        <script src="https://code.jquery.com/jquery-3.6.0.js"></script>
                        <script>{"console.log('salut lucas rodriguez')"}</script>

                        <script src="https://cdnjs.cloudflare.com/ajax/libs/mermaid/8.13.4/mermaid.min.js"></script>
                        <script>{
                            "mermaid.init()"
                        }</script>
                        <script src="https://polyfill.io/v3/polyfill.min.js?features=es6"></script>
                        <script id="MathJax-script" async src="https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-mml-chtml.js"></script>
                        {/*  <script type="text/javascript" async src="https://cdn.mathjax.org/mathjax/latest/MathJax.js?config=TeX-AMS_CHTML"></script>*/}
                    </Helmet>
                    <div className={"article_container"}>
                        <p className="small"><i className="fa fa-arrow-left"></i>&nbsp; <NavLink to="/articles">Go back to articles</NavLink>{/* &bull; Last modified : <i>{last_modified_date}</i>*/}</p>

                        <div className={"article_content"} id="article_content" dangerouslySetInnerHTML={{ __html: formatted_article_content }}>
                        </div>
                        <div className={"article_links"}>
                            <p className="text-muted small">
                                <i className="fa fa-github"></i> <a href={`https://github.com/lcsrodriguez/articles/tree/main/articles/${article_slug}`} target="_BLANK">GitHub repo</a>
                                &nbsp;&bull;&nbsp;
                                <i className="fa fa-file-pdf-o"></i> <a href="#">PDF version</a>
                                &nbsp;&bull;&nbsp;
                                <i className="fa fa-file-text-o"></i> <a href="#">Markdown version</a>
                                &nbsp;&bull;&nbsp;
                                <i className="fa fa-medium"></i> <a href="#">Medium version</a>
                            </p>
                        </div>
                    </div>
                </div >
            );
        }
        else
        {
            console.log("SLUG NOT OK")
            return <Redirect to='/articles' />
        }
        {/*
        return (
            <div>
                <Helmet title="Article n°1">

                    <script src="https://code.jquery.com/jquery-3.6.0.js"></script>
                    <script>{"console.log('salut lucas rodriguez')"}</script>

                    <script src="https://cdnjs.cloudflare.com/ajax/libs/mermaid/8.13.4/mermaid.min.js"></script>
                    <script>{
                        "mermaid.init()"
                    }</script>
                </Helmet>
        <pre>
            <code className="language-python">
                import json
                print("l")
            </code>
        </pre>
        $$f(x)$$
            < div className = "mermaid" >
            {
                "graph TD;A-->B; "
                    }
                </div >
            </div >
                );*/}
    }
}
export default Articles;


